import React from 'react';
import PropTypes from 'prop-types';
import Theme from "./Theme.js";
import Layout from "./Layout.js";
import S from './Pane.css';

/** 
 * React class that renders a pane 
 * @property {string} className - css class to be applied to this component 
 * @property {boolean} inline - adds inline properties to the pane 
 * @property {string} variant - Theme variant name to be added to the component 
 * */
import { jsx as _jsx } from "react/jsx-runtime";
class Pane extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    inline: PropTypes.bool,
    variant: PropTypes.string
  };
  static defaultProps = {
    className: null,
    inline: false,
    variant: null
  };
  render() {
    const theme = this.context;
    const {
      className,
      variant,
      layout,
      inline,
      children,
      domRef,
      ...rest
    } = this.props;
    const lcn = Layout.classes(theme, layout); // theme.classes( 'Layout', 'layout', layout )
    const cn = theme.classes('Pane', 'pane', variant, S.pane, inline && S.inline, className, lcn);
    return /*#__PURE__*/_jsx("div", {
      className: cn,
      ref: domRef,
      ...rest,
      children: Layout.renderLayout(theme, layout, children)
    });
  }
}
export default Pane;